// APIモジュールの名前を管理する
// 各モジュールの配置箇所は「APIモジュール一覧」を参照のこと

export const KWANKGM00000A17 = 'KWANKGM00000A17';
export const KWANKGM00000A18 = 'KWANKGM00000A18';
export const KWANKGM00000A19 = 'KWANKGM00000A19';
export const KWANKGM00000A20 = 'KWANKGM00000A20';
export const KWANKGM00000A21 = 'KWANKGM00000A21';
export const KWANKGM00000A22 = 'KWANKGM00000A22';
export const KWANKGM00000A23 = 'KWANKGM00000A23';
export const KWANKGM00000A24 = 'KWANKGM00000A24';
export const KWANKGM00000A25 = 'KWANKGM00000A25';
export const KWANKGM00000A26 = 'KWANKGM00000A26';

export const KWANKGM00050A02 = 'KWANKGM00050A02';
export const KWANKGM00050A03 = 'KWANKGM00050A03';
export const KWANKGM00060A02 = 'KWANKGM00060A02';

export const KWANKGM00140A01 = 'KWANKGM00140A01';

export const KWANKGM00150A01 = 'KWANKGM00150A01';
export const KWANKGM00150A03 = 'KWANKGM00150A03';

export const KWANKGM00240A01 = 'KWANKGM00240A01';
export const KWANKGM00240A02 = 'KWANKGM00240A02';

export const KWANKGM10050A02 = 'KWANKGM10050A02';
export const KWANKGM10060A01 = 'KWANKGM10060A01';
export const KWANKGM10070A01 = 'KWANKGM10070A01';
export const KWANKGM10090A01 = 'KWANKGM10090A01';
export const KWANKGM10090A02 = 'KWANKGM10090A02';
export const KWANKGM10090A02_Validate = 'KWANKGM10090A02_Validate';
export const KWANKGM10090A03 = 'KWANKGM10090A03';
export const KWANKGM10090A04 = 'KWANKGM10090A04';

export const KWANKGM10100A01 = 'KWANKGM10100A01';
export const KWANKGM10100A01_Validate = 'KWANKGM10100A01_Validate';

export const KWANKGM11010A01 = 'KWANKGM11010A01';
export const KWANKGM11010A02 = 'KWANKGM11010A02';
export const KWANKGM11010A03 = 'KWANKGM11010A03';
export const KWANKGM11010A04 = 'KWANKGM11010A04';
export const KWANKGM11020A01 = 'KWANKGM11020A01';

export const KWANKGM02020A01 = 'KWANKGM02020A01';
export const KWANKGM02020A01_Autodisplay = 'KWANKGM02020A01_Autodisplay';
export const KWANKGM02020A01_Validate = 'KWANKGM02020A01_Validate';
export const KWANKGM02040A01 = 'KWANKGM02040A01';
export const KWANKGM02040A02 = 'KWANKGM02040A02';

export const KWANKGM03020A01 = 'KWANKGM03020A01';
export const KWANKGM03020A01_Autodisplay = 'KWANKGM03020A01_Autodisplay';
export const KWANKGM03020A01_Validate = 'KWANKGM03020A01_Validate';
export const KWANKGM03040A01 = 'KWANKGM03040A01';

export const KWANKGM04010A01 = 'KWANKGM04010A01';
export const KWANKGM04030A03_Autodisplay = 'KWANKGM04030A03_Autodisplay';
export const KWANKGM04030A03_Validate = 'KWANKGM04030A03_Validate';
export const KWANKGM04030A03 = 'KWANKGM04030A03';
export const KWANKGM04030A04 = 'KWANKGM04030A04';
export const KWANKGM04030A05 = 'KWANKGM04030A05';
export const KWANKGM04050A01 = 'KWANKGM04050A01';
export const KWANKGM04050A02 = 'KWANKGM04050A02';
export const KWANKGM04080A01 = 'KWANKGM04080A01';
export const KWANKGM04080A02 = 'KWANKGM04080A02';

export const KWANKGM04210A01 = 'KWANKGM04210A01';

export const KDANKGM05010A01 = 'KDANKGM05010A01';
export const KDANKGM05010A02 = 'KDANKGM05010A02';
export const KDANKGM05020A01 = 'KDANKGM05020A01';
export const KDANKGM05020A02 = 'KDANKGM05020A02';

export const KWANKGM04330A01 = 'KWANKGM04330A01';
export const KWANKGM04330A02 = 'KWANKGM04330A02';

export const KWANKGM04240A01 = 'KWANKGM04240A01';
export const KWANKGM04240A02_Autodisplay = 'KWANKGM04240A02_Autodisplay';
export const KWANKGM04240A02_Validate = 'KWANKGM04240A02_Validate';

export const KWANKGM04240A02 = 'KWANKGM04240A02';

export const KWANKGM04270A01 = 'KWANKGM04270A01';
export const KWANKGM04270A02_Autodisplay = 'KWANKGM04270A02_Autodisplay';
export const KWANKGM04270A02_Validate = 'KWANKGM04270A02_Validate';

export const KWANKGM04270A02 = 'KWANKGM04270A02';
export const KWANKGM04290A01 = 'KWANKGM04290A01';
export const KWANKGM04290A02 = 'KWANKGM04290A02';

export const KDANKGM05050A02 = 'KDANKGM05050A02';
export const KDANKGM05050A01 = 'KDANKGM05050A01';

export const KWANKGM02060A01 = 'KWANKGM02060A01';
export const KWANKGM02060A02 = 'KWANKGM02060A02';

export const KWANKGM03110A02 = 'KWANKGM03110A02';
export const KWANKGM03130A02 = 'KWANKGM03130A02';
export const KWANKGM03130A03 = 'KWANKGM03130A03';

export const KWANKGM03130A01 = 'KWANKGM03130A01';

export const KWANKGM02020A02 = 'KWANKGM02020A02';

export const KWANKGM03160A01 = 'KWANKGM03160A01';
export const KWANKGM03160A02 = 'KWANKGM03160A02';

export const KWMNTGM05100A02 = 'KWMNTGM05100A02';
export const KWMNTGM05010A02 = 'KWMNTGM05010A02';
export const KWMNTGM05020A02 = 'KWMNTGM05020A02';
export const KWMNTGM05030A01 = 'KWMNTGM05030A01';
export const KWMNTGM05040A02 = 'KWMNTGM05040A02';
export const KWMNTGM05050A02 = 'KWMNTGM05050A02';
export const KWMNTGM05060A02 = 'KWMNTGM05060A02';
export const KWMNTGM05080A01 = 'KWMNTGM05080A01';
export const KWMNTGM05090A02 = 'KWMNTGM05090A02';
export const KWMNTGM05110A02 = 'KWMNTGM05110A02';
export const KWMNTGM05110A03 = 'KWMNTGM05110A03';

export const KWANKGM03130A01_Autodisplay = 'KWANKGM03130A01_Autodisplay';
export const KWANKGM03130A01_Validate = 'KWANKGM03130A01_Validate';